import React, {useEffect} from "react";
import MainRouter from "./components/MainRouter";
import MainState from "./state/main/MainState";
import "./scss/main.scss";
import ReactGA from 'react-ga';

const trackingId = "UA-181409548-1"; 

const App = () => {
  useEffect(() => {
    ReactGA.initialize(trackingId);
    ReactGA.pageview(window.location.pathname); 
    console.log({id: trackingId, pathname: window.location.pathname})
  }, [])
  return (
    <MainState>
      <MainRouter />
    </MainState>
  );
};

export default App;
